import api from './api';

const dashboardService = {
  getStats:      (token) => api.get('/dashboard/stats', token),
  getActivities: (token) => api.get('/dashboard/activities', token),
};

export default dashboardService;
